import { Col, Form, Row } from "react-bootstrap"

import CardRow from "./CardRow"
import PhoneType, { PhoneNumber } from "../../../../api/PhoneType"
import PhoneNumberMaskedInput from "../../../FormattedInputs/PhoneNumberMaskedInput"
import FormatPhone from "../../../../formatters/FormatPhone"

interface PhoneNumberCardProps {
  variant: PhoneType
  readonly: boolean
  phone: PhoneNumber
  onChange: (value: string, type: PhoneType) => void
}

function PhoneNumberCard(props: PhoneNumberCardProps) {
  const { variant, readonly, phone, onChange } = props

  const label = () => {
    switch (variant) {
      case PhoneType.Home:
        return "HOME PHONE"
      case PhoneType.Work:
        return "WORK PHONE"
      case PhoneType.Cell:
        return "MOBILE PHONE"
      default:
        return ""
    }
  }

  const onNumberChange = (number: string) => onChange(number, variant)

  const isValid = (phone: string) => {
    const phoneNumber = phone.replace(/\D/g, "")

    return phoneNumber.length === 0 || phoneNumber.length === 10
  }

  return (
    <>
      {readonly && <CardRow title={`${label()}`} value={FormatPhone(phone.number)} />}
      {!readonly && (
        <Row className="p-1">
          <Form.Label column sm={4} className={`align-middle ${phone.isRequired ? "required" : ""}`} htmlFor={`${variant}Input`}>
            {`${label()}`}
          </Form.Label>
          <Col md={8} className="align-self-center">
            <PhoneNumberMaskedInput
              id={`${variant}Input`}
              value={phone.number}
              isInvalid={!isValid(phone.number)}
              onChange={onNumberChange}
            />
          </Col>
        </Row>
      )}
    </>
  )
}

export default PhoneNumberCard
